import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Reveal } from "@/components/site/primitives";

const STAT_ITEMS = [
  { target: 275, suffix: "", label: "Farmers in our program" },
  { target: 25, suffix: "", label: "Countries represented" },
  { target: 135, suffix: "", label: "Acres in production" },
  { target: 140, suffix: "+", label: "Communities served" },
];

const format = (n, comma) => (comma ? n.toLocaleString("en-US") : String(n));

const CountUp = ({ target, comma, suffix, active }) => {
  const [val, setVal] = useState(0);
  const reduced = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  useEffect(() => {
    if (!active) return;
    if (reduced) { setVal(target); return; }
    let raf; const start = performance.now(); const dur = 1500;
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active, target, reduced]);
  return (
    <span className="font-serif text-5xl font-semibold text-[var(--wf-paper)] sm:text-6xl">
      {format(val, comma)}{suffix}
    </span>
  );
};

export const AnimatedStats = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  return (
    <section ref={ref} aria-labelledby="impact-heading" className="wf-grain relative overflow-hidden bg-[var(--wf-farm-green)] py-16 sm:py-20">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[radial-gradient(700px_400px_at_80%_0%,rgba(255,253,248,0.10),transparent_60%)]" />
      <div className="wf-container relative">
        <Reveal className="max-w-2xl">
          <h2 id="impact-heading" className="font-serif text-4xl font-semibold text-[var(--wf-paper)] sm:text-5xl lg:text-6xl">
            Our Impact
          </h2>
        </Reveal>
        <dl className="mt-10 grid grid-cols-2 gap-8 lg:grid-cols-4">
          {STAT_ITEMS.map((s) => (
            <div key={s.label} className="border-l-2 border-[rgba(255,253,248,0.28)] pl-4">
              <dt className="sr-only">{s.label}</dt>
              <dd><CountUp {...s} active={inView} /></dd>
              <p className="mt-2 text-xs uppercase tracking-[0.14em] text-[rgba(255,253,248,0.78)]">{s.label}</p>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};
